export const J2000 = 2451545.0;
const DAY_MS = 86400000;
export const DAY_S = 86400;
const UNIX_EPOCH_JD = 2440587.5;
export const DEG = Math.PI / 180;
const TWO_PI = 2 * Math.PI;

export function dateToJd(date: Date): number {
  return date.getTime() / DAY_MS + UNIX_EPOCH_JD;
}

export function jdToDate(jd: number): Date {
  return new Date((jd - UNIX_EPOCH_JD) * DAY_MS);
}

export function centuriesSinceJ2000(jd: number): number {
  return (jd - J2000) / 36525;
}

/** Parses JPL's "YYYY-MM-DD.f" epoch notation (TDB treated as UTC; the difference is ~69 s). */
export function parseJplEpoch(text: string): number {
  const m = /^(\d{4})-(\d{2})-(\d{2})(?:\.(\d+))?$/.exec(text.trim());
  if (!m) throw new Error(`unparseable JPL epoch "${text}"`);
  const fraction = m[4] ? Number(`0.${m[4]}`) : 0;
  const midnight = Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return midnight / DAY_MS + UNIX_EPOCH_JD + fraction;
}

export function wrapTwoPi(x: number): number {
  const r = x % TWO_PI;
  return r < 0 ? r + TWO_PI : r;
}
